import { render, staticRenderFns } from "./PromoHistoryTable.vue?vue&type=template&id=268df8b1"
import script from "./PromoHistoryTable.vue?vue&type=script&lang=js"
export * from "./PromoHistoryTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports